<template>
  <div>
    <util-tab-title title="Pencatatan Terakhir" action="/utilities/air"></util-tab-title>
    <util-chart :chartdata="chart"></util-chart>
    
    <util-add action="/utilities/air/add" v-if="group == 'Operator Utilities'"></util-add>
    <util-item-air  :listdata="list"></util-item-air>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UtilChart from "@/views/pages/Utilities/Components/Util-Chart.vue";
import UtilTabTitle from "@/views/pages/Utilities/Components/Util-Tab-Title.vue";
import UtilItemAir from "@/views/pages/Utilities/Components/Util-Item-Air.vue";
import UtilAdd from "@/views/pages/Utilities/Components/Util-Add.vue";
import { api } from "@/api/api.js";
import { UserModule } from "@/store/modules/user";

@Component({
    components: {
      UtilChart,
      UtilTabTitle,
        UtilAdd,
      UtilItemAir
    },
})
export default class UtilitiesAir extends Vue {

  list = [];
  chart = {series:[],labels:[]};
  mounted(){
    api('air_list').then(res => {
      this.list = res.data.data.map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
    })
    api('air_chart').then(res => {
      let data = res.data
      this.chart.series = data.map(e=>Number(`${e.value}`))
      this.chart.labels = data.map(e=>e.tgl)
    })
  }
  group = UserModule.userDetail.accessgroup['name'];
}
</script>
